cms-icon {    
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  .cms-icon-spin {
    animation: cms-icon-spin 2s infinite linear;
  }

  @keyframes cms-icon-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
